import { useEffect } from "react"
import { useLocation } from "react-router-dom"

import {
  getUmamiConfig,
  loadUmamiScript,
  shouldLoadUmami,
  trackUmamiPageview,
} from "@/lib/umami"

/** Loads Umami and tracks marketing page views (SPA). Skipped when opted out or DNT. */
export function MarketingAnalytics() {
  const { pathname, search } = useLocation()

  useEffect(() => {
    if (!shouldLoadUmami()) return

    const config = getUmamiConfig()
    if (!config) return

    let cancelled = false

    loadUmamiScript(config)
      .then(() => {
        if (!cancelled) {
          trackUmamiPageview(`${pathname}${search}`)
        }
      })
      .catch(() => {
        // Analytics must never break the page.
      })

    return () => {
      cancelled = true
    }
  }, [pathname, search])

  return null
}
